var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdgrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14283",
    "data-name": "Group 14283",
    transform: "translate(-429 -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3738",
    "data-name": "Rectangle 3738",
    transform: "translate(429 141)",
    fill: "#fff",
    stroke: "#868a97",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13389",
    "data-name": "Path 13389",
    d: "M2.337,11.047H1.114v-8H2.337Zm1.509,0v-8H5.932a2.976,2.976,0,0,1,1.662.473A3.089,3.089,0,0,1,8.716,4.86a4.726,4.726,0,0,1,.4,1.989v.4a4.706,4.706,0,0,1-.4,2,3.04,3.04,0,0,1-1.14,1.33,3.109,3.109,0,0,1-1.7.467ZM5.073,4.168V9.937h.8a1.746,1.746,0,0,0,1.482-.684,3.255,3.255,0,0,0,.526-1.964V6.844a3.351,3.351,0,0,0-.5-1.989,1.683,1.683,0,0,0-1.451-.687Z",
    transform: "translate(431.886 141.953)",
    fill: "#868a97"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdgrey);
export default __webpack_public_path__ + "static/media/idgrey.a9981a41d01c0897e17547fae6e36029.svg";
export { ForwardRef as ReactComponent };